import { Link } from 'react-router-dom';

export default function TestimonialsHero() {
  return (
    <section className="relative min-h-[60vh] flex items-center overflow-hidden bg-[#F8F5F0]">
      {/* Right image */}
      <div className="absolute top-0 right-0 w-[48%] h-full hidden lg:block">
        <img
          src="https://readdy.ai/api/search-image?query=warm%20professional%20meeting%20handshake%20trust%20relationship%20advisor%20client%20consultation%20office%20natural%20light%20smiling%20confident%20calm%20atmosphere%20minimal&width=900&height=700&seq=testhero001&orientation=squarish"
          alt="客戶見證 保險建築師"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#F8F5F0] via-[#F8F5F0]/55 to-transparent"></div>
      </div>

      <div
        className="absolute inset-0 opacity-[0.04]"
        style={{ backgroundImage: 'radial-gradient(#5C5470 1px, transparent 1px)', backgroundSize: '24px 24px' }}
      ></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-10 pt-28 pb-20">
        <div className="max-w-[580px]">
          <div className="inline-flex items-center gap-2 bg-[#5C5470]/10 border border-[#5C5470]/20 rounded-full px-4 py-2 mb-8">
            <span className="w-2 h-2 rounded-full bg-[#D4A373]"></span>
            <span className="text-[#5C5470] font-medium" style={{ fontSize: '1rem' }}>真實客戶回饋</span>
          </div>

          <h1
            className="font-serif font-bold text-[#5C5470] mb-6"
            style={{ fontSize: 'clamp(2rem, 4vw, 2.75rem)', lineHeight: '1.3' }}
          >
            客戶見證
            <br />
            <span className="text-[#D4A373]">每一次託付，</span>
            <br />
            都是一座安心的開始
          </h1>

          <p
            className="text-[#5C5470]/75 mb-10"
            style={{ fontSize: '1.1875rem', lineHeight: '1.75' }}
          >
            從保單健檢、家庭醫療保障到企業團體方案，保險建築師陪伴客戶看懂風險、整理需求、建立更穩定的保障結構。
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 bg-[#D4A373] text-white px-8 py-4 rounded-full font-semibold whitespace-nowrap hover:bg-[#c4935f] transition-all duration-200 hover:scale-105"
              style={{ fontSize: '1.1875rem' }}
            >
              <i className="ri-calendar-check-line"></i>
              預約一對一諮詢
            </Link>
            <Link
              to="/about#health-check-form"
              className="inline-flex items-center justify-center gap-2 border-2 border-[#5C5470] text-[#5C5470] px-8 py-4 rounded-full font-semibold whitespace-nowrap hover:bg-[#5C5470] hover:text-white transition-all duration-200"
              style={{ fontSize: '1.1875rem' }}
            >
              <i className="ri-file-search-line"></i>
              免費保單健檢
            </Link>
          </div>

          <div className="mt-12 lg:hidden rounded-2xl overflow-hidden aspect-[16/9]">
            <img
              src="https://readdy.ai/api/search-image?query=warm%20professional%20meeting%20handshake%20trust%20relationship%20advisor%20client%20consultation%20office%20natural%20light%20smiling%20confident%20calm%20atmosphere%20minimal&width=800&height=450&seq=testhero002&orientation=landscape"
              alt="客戶見證"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
